import styled from "styled-components";

import { BorderRadiusPill, ColorNeutralBlack, ColorTransparency00, FontFamilyDMSans } from "ds/Core";

import { getAvatarStyles } from "./theme";
import { AvatarProps } from "./types";

export const StyledAvatar = styled.div<AvatarProps>`
  background-color: ${({ color, url }) => (url ? ColorTransparency00 : color)};
  border-radius: ${BorderRadiusPill};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;

  > span {
    color: ${ColorNeutralBlack};
    line-height: 0px;
    font-family: ${FontFamilyDMSans};
    pointer-events: none;
    background-color: ${({ color }) => color};
    position: absolute;
    inset: 0;
    display: grid;
    place-items: center;
  }

  ${({ size }) => getAvatarStyles({ size })};

  ${({ url }) =>
    url &&
    `
      background-image: url("${url}");
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
  `}
`;
